import React from 'react';
import { omit } from 'lodash/fp';

const ConvertedSelect = (props) => {
  let selectedVal;
  const options = React.Children.map(props.children, (child) => {
    if (child.type === 'option') {
      if (child.props.selected) {
        selectedVal = child.props.value;
      }
      return React.cloneElement(child, { selected: undefined });
    }
    return child;
  });

  return (
    <select {...props} defaultValue={selectedVal}>
      {options}
    </select>
  );
};

const ConvertedInput = (props) => {
  const { type, checked, value } = props;
  if (type === 'checkbox' || type === 'radio') {
    return <input {...omit('checked', props)} defaultChecked={checked} />;
  }
  return <input {...omit('value', props)} defaultValue={value || undefined} />;
};

const ConvertedTextArea = (props) => {
  const textVal = React.Children.toArray(props.children).join('');

  return (
    <textarea
      {...omit('children', props)}
      defaultValue={textVal || undefined}
    ></textarea>
  );
};

const transform = {
  input: ConvertedInput,
  select: ConvertedSelect,
  textarea: ConvertedTextArea,
};

export default transform;
